<style>
    .deviceunlocked {
        opacity:1
    }
    .devicelocked {
        opacity:0.4
    }
</style>

<template >
    <div>
        <div class="topbar " style="text-align:left;background-color:#39a9dc;" >
          <v-icon 
            class="close-button" 
            v-on:click="$emit('leaveView')" 
            >
                close
            </v-icon>
        </div>
        <v-layout style="position:relative" row wrap>
            <v-toolbar tabs 
                    class="elevation-0">
            <v-icon>
                {{(device.attributes.isGateway)?model.gatewayIcon:model.default}}
            </v-icon>
                <v-toolbar-title style="text-align:left;">
        
                    {{(device.attributes.customName)?device.attributes.customName:device.id}}
                    <v-layout justify-space-around row wrap >
                        <v-layout>
                            <v-flex>
                                <v-layout>
                                <v-flex body-1>{{device.id}}</v-flex>
                                <v-flex 
                                    style="margin-left:2rem"
                                    caption 
                                    v-if="device.attributes.gateway!=null&&device.attributes.gateway!=undefined">
                                    <v-icon small>{{model.gatewayIcon}}</v-icon>
                                    {{device.attributes.gateway}}
                                </v-flex>
                                <v-flex 
                                    style="margin-left:2rem"
                                    caption 
                                    v-if="device.attributes.proxyGateway!=null&&device.attributes.proxyGateway!=undefined">
                                    <v-icon small>{{model.gatewayIcon}}</v-icon>
                                    {{device.attributes.proxyGateway}}
                                </v-flex>
                                </v-layout>
                            </v-flex>

                        </v-layout>

                    </v-layout>
                </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon>
                <v-icon color="red" v-on:click="deleteDevice()">delete_forever</v-icon>
            </v-btn>

            <template v-slot:extension>
                <v-tabs
                    v-model="tabs"
                    fixed-tabs
                    color="transparent"
                >
                <v-tabs-slider
                    color="amber"
                ></v-tabs-slider>
                
                <v-tab 
                    v-for="(value,index) in model.fields" :href="`#${index}`" :key="index"
                    v-on:click="selectedTab(index)"
                >
                    <v-icon>{{value.icon}}</v-icon>
                </v-tab>

                </v-tabs>
            </template>
            </v-toolbar>

            <inprogress  :dialog="viewDisabled" :message="viewDisabledLabel" button="Close" v-on:clicked="$emit('leaveView')"></inprogress>

            <v-tabs-items 
                v-model="tabs"
                style="width:100%"
            > 

                <!-- State view -->
                <v-tab-item
                    value="state"
                    v-if="model.fields.state"
                    class="white text-capitalize"
                >
                    <!-- <v-layout justify-end style="margin-top:0.5rem;margin-bottom:-1rem">
                        <v-btn class="ma-2"  color="info"   v-on:click="updateConfigurationDevice()">
                            <v-icon left>save</v-icon> Save
                        </v-btn>
                    </v-layout> -->

                    <v-layout  row wrap style="margin-top:1rem;">
                        <v-flex 
                            d-flex xs12 sm6 md6  
                            style="padding:1rem;"
                            v-for="(value,index) in model.fields.state.fields"
                            :key="index"    
                        >
                            <v-card tile flat class="elevation-1" style="position:relative;text-align:left;padding-bottom:0.4rem;width:100%">
                                <v-card-title 
                                class="font-weight-medium white--text"
                                                
                                style="
                                    margin-top:1rem;
                                    border-style: solid;
                                    border-width: 0em 0em 0em 0.3em;
                                    border-color: #FFC107;  
                                    background-color: #39a9dc;
                                    margin-top:-0.1rem
                                "
                                >
                                    <v-icon small left color="white" >{{value.icon}}</v-icon>
                                    <span>{{value.name}}</span>
                                </v-card-title>

                                <v-card-text > 
                                    <div 
                                        row-wrap
                                        v-for="(subValue,subIndex) in value.fields"   
                                        :key="subIndex" 
                                        style="margin-bottom:1rem;"
                                    >   
                                        <v-layout 
                                            align-center 
                                            row wrap
                                            v-if="
                                                resolve(subValue.path,device)==undefined &&
                                                resolve(subValue.path,device)==null &&
                                                subValue.showIfNotExistOrEmpty == true
                                            "
                                        >
                                            <div style="position:absolute;top:5rem;;bottom:1rem;width:95%;opacity:0.7" >
                                                <v-layout style="height:100%;color:grey" align-center justify-center>
                                                    <v-icon big style="font-size:2rem;margin-right:0.5rem" color="grey">{{value.icon}}</v-icon> <span class="body-2" > No {{value.name}} </span>
                                                </v-layout>
                                            </div>
                                        </v-layout>
                                        <v-layout 
                                            align-center 
                                            row wrap
                                            v-else
                                        >
                                            <v-flex 
                                                style="padding-left:3.2rem;margin-top:-1rem;"
                                                v-if="subValue.view.type.toLowerCase()=='list'" xs12 sm12 md12>

                                                <v-list style="margin-left:1.1rem;margin-bottom:-0.6rem" >
                                                    <v-list-tile 
                                                        style="margin-left:-1.5rem;margin-bottom:-0.9rem"
                                                        v-if="prepareList(resolve(subValue.path,device),subValue).complex">
                                                        <span class="body-2">
                                                            <v-icon small style="margin-right:0.2rem">{{subValue.icon}}</v-icon>
                                                            {{subValue.name}}
                                                        </span>
                                                    </v-list-tile>
                                                    <v-list-group
                                                        v-for="(item,index) in prepareList(resolve(subValue.path,device),subValue)"
                                                        :key="index"
                                                        no-action
                                                        :prepend-icon="item.icon"
                                                        style="margin-bottom:-1rem"
                                                    >
                                                        <template v-slot:activator>
                                                        <v-list-tile >
                                                            <v-list-tile-content>
                                                            <v-list-tile-title class="body-1" >
                                                                {{(item.group)?item.group:subValue.name}}
                                                            </v-list-tile-title>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                        </template>

                                                        <v-list-tile
                                                            v-for="(subItem,index) in item.items"
                                                            :key="index"
                                                        >
                                                        <v-list-tile-content>
                                                            <v-list-tile-content 
                                                            >
                                                                <v-layout class="body-1">
                                                                    <v-flex 
                                                                        v-for="(field,index) in subValue.view.schema"    
                                                                        :key="index"
                                                                        class="align-start"
                                                                        style="padding-left:5rem"
                                                                    >
                                                                        <div v-if="field.type.toLowerCase()=='img'">
                                                                            <img 
                                                                                style="width:2rem;"
                                                                                :src="resolve(field.path,subItem)"
                                                                            />
                                                                        </div>
                                                                        <div v-else>{{resolve(field.path,subItem)}}</div>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-list-group>
                                                </v-list>
                                            </v-flex>

                                            <v-flex 
                                                style=""
                                                v-if="subValue.view.type.toLowerCase()=='gauge'" xs12 >
                                                <v-layout row wrap style="">
                                                   
                                                    <v-flex 
                                                        v-for="(gougeItem, index) in resolve(subValue.path,device)"
                                                        style=""
                                                        :key="index" xs6 sm6 md4>
                                                        
                                                        <gauge 
                                                            v-if="gougeItem"
                                                            :name="resolve(subValue.view.labelPath,gougeItem)"
                                                            :value="resolve(subValue.view.valuePath,gougeItem)"
                                                            :img="subValue.view.imgPath?resolve(subValue.view.imgPath,gougeItem):null"
                                                            :icon="icons[resolve(subValue.view.labelPath,gougeItem)]"
                                                            :ranges="[22,44,66,88]"
                                                            style="transform:scale(0.7)"
                                                            :isAMessage="subValue.view.text"
                                                            :severity="subValue.view.severityPath?resolve(subValue.view.severityPath,gougeItem):null"
                                                        >
                                                        </gauge>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex 
                                                style=""
                                                v-if="subValue.view.type.toLowerCase()=='map'" xs12 >
                                                <MapView 
                                                    style="z-index:0;width:100%" 
                                                    v-on:clickMap="()=>{}" 
                                                    v-on:clickMarker="()=>{}" 
                                                    v-on:clickPath="()=>{}" 
                                                    :markers="buildMarkers(resolve(subValue.path,device))" 
                                                    :height="'20rem'"  />   
                                            </v-flex>


                                            <v-flex 
                                                xs3 sm3 md3 style=""
                                                v-if="subValue.view.type.toLowerCase()!='list'&&subValue.view.type.toLowerCase()!='gauge'&&subValue.view.type.toLowerCase()!='map'" 
                                            >
                                                <span>
                                                    <v-icon small style="margin-right:0.2rem">
                                                        {{subValue.icon}}
                                                    </v-icon>
                                                    {{subValue.name}}                                                    
                                                </span>
                                            </v-flex>
                                            <v-flex xs9 sm9 md9>
                                                <div v-if="subValue.view.type.toLowerCase()=='led'" >
                                                    <led
                                                        :classObj="subValue.view.style[resolve(subValue.path,device)+'']"
                                                        :label="(!subValue.view.nolabel)?resolve(subValue.path,device):null"
                                                    ></led>
                                                </div>
                                                <div v-else-if="subValue.view.type.toLowerCase()=='switch'">
                                                    <custom-switch
                                                        v-model="configuration[subValue.to]"
                                                        :mapValues="subValue.view.mapValues"
                                                        :unMapValues="subValue.view.unMapValues"                                  
                                                    ></custom-switch>
                                                </div>
                                                <div v-else-if="subValue.view.type.toLowerCase()=='slider'">
                                                    <v-slider
                                                        v-model="configuration[subValue.to]"
                                                        thumb-color="red"
                                                        thumb-label="always"
                                                        :min="subValue.min"
                                                        :max="subValue.max"
                                                    ></v-slider>
                                                </div>
                                                <div v-else-if="
                                                    subValue.view.type.toLowerCase()=='list'||
                                                    subValue.view.type.toLowerCase()=='gauge'||
                                                    subValue.view.type.toLowerCase()=='map'
                                                ">
                                                </div>
                                                <div v-else-if="subValue.view.type.toLowerCase()=='date'" >{{new Date(resolve(subValue.path,device))}}</div>
                                                <div v-else-if="subValue.view.type.toLowerCase()=='currentoffsetdate'" >
                                                    <current-offset-date-component
                                                    :timestamp="resolve(subValue.path,device)"
                                                    ></current-offset-date-component>
                                                </div>
                                                <div v-else-if="subValue.view.type.toLowerCase()=='img'">
                                                    <img 
                                                        :style="'width:'+resolve(subValue.view.widthPath,device)+'rem;margin-left:'+resolve(subValue.view.marginLeftPath,device)+'rem'"
                                                        :src="resolve(subValue.path,device)"
                                                    />
                                                </div>
                                                <div v-else-if="subValue.view.type.toLowerCase()=='select'">
                                                    <div v-if="subValue.configurable==true">
                                                        <v-select 
                                                            :items="values[subValue.name]"
                                                            :label="subValue.label"
                                                            item-value="ref"
                                                            item-text="text"
                                                            v-model="configuration[subValue.to]"
                                                            :value="resolve(subValue.path,device)"
                                                            v-on:change="(subValue.type=='number')?configuration[subValue.to]=parseInt(configuration[subValue.to]):configuration[subValue.to]=configuration[subValue.to]"
                                                        >
                                                        </v-select>
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <div v-if="subValue.configurable==true">
                                                        <v-text-field 
                                                            solo style="margin-top:1rem"
                                                            :type="subValue.type"
                                                            v-model="configuration[subValue.to]"
                                                            v-on:change="(subValue.type=='number')?configuration[subValue.to]=parseInt(configuration[subValue.to]):configuration[subValue.to]=configuration[subValue.to]"
                                                            :value="resolve(subValue.path,device)">
                                                        </v-text-field>
                                                    </div>
                                                    <div v-else>
                                                        <span>{{resolve(subValue.path,device)}}</span>
                                                    </div>
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                    </div>
                                </v-card-text>
                            </v-card>            
                        </v-flex>

                    </v-layout>
                    <v-layout justify-end style="margin-top:0.5rem;margin-bottom:-1rem">
                        <v-btn outline class="ma-2"  color="info"   v-on:click="updateConfigurationDevice()">
                            <v-icon left>save</v-icon> Save
                        </v-btn>
                    </v-layout>
                </v-tab-item>

                <!-- Control view -->
                <v-tab-item
                    value="control"
                    v-if="model.fields.control"
                >
                    <v-layout row wrap style="margin-top:1rem">
                        <v-flex 
                            d-flex xs12 sm12 style="margin-top:1rem;"
                            v-if="model.fields.control.fields.commands"
                        >
                            <v-card  
                                tile flat class="elevation-2" style="text-align:left;padding-bottom:0.4rem"
                                v-if="resolve(model.fields.control.fields.commands.path,device)"
                            >
                                <v-card-title class="font-weight-medium">
                                    <v-icon small left>{{model.fields.control.fields.commands.icon}}</v-icon>
                                    <span>{{model.fields.control.fields.commands.label}}</span>
                                </v-card-title>

                                <v-card-text> 
                                    <v-layout 
                                        align-center
                                        row-wrap
                                        v-for="(subValue,subIndex) in resolve(model.fields.control.fields.commands.path,device)"   
                                        :key="subIndex" 
                                        style="margin-bottom:0.5rem"
                                    >
                                        
                                        <v-layout 
                                            align-center >
                                            <v-flex xs6 sm6 md6 style="padding-left:2rem" >
                                                <span>
                                                    <v-btn flat icon v-on:click="startControl(subValue)">
                                                        <v-icon small color="purple">
                                                            {{model.fields.control.fields.commands.itemIcon}}
                                                        </v-icon>
                                                    </v-btn>
                                                    {{subValue.name}}
                                                </span>
                                            </v-flex>
                                            <v-flex xs5 sm5 md5 >
                                                <span>
                                                    {{subValue.description}}
                                                </span>
                                            </v-flex>
                                        </v-layout>
                                    </v-layout>
                                </v-card-text>
                            </v-card>            
                        </v-flex>
                        
                        <!-- Debug control -->
                        <!-- <v-flex style="margin-top:20px">
                            <v-card  
                                tile flat class="elevation-2" style="text-align:left;padding-bottom:0.4rem"
                                v-if="resolve(model.fields.control.fields.commands.path,device)"
                            >
                                <v-card-title class="font-weight-medium">
                                    <v-icon small left>{{model.fields.control.fields.commands.icon}}</v-icon>
                                    <span>{{model.fields.control.fields.commands.label}}  - Debug</span>
                                </v-card-title>

                                <v-card-text> 
                                    <v-layout 
                                        align-center
                                        row-wrap
                                        v-for="(subValue,subIndex) in model.fields.control.fields.commands.fields"   
                                        :key="subIndex" 
                                        style="margin-bottom:0.5rem"
                                    >
                                        <v-layout 
                                            align-center
                                            v-if="subValue.important == true"
                                        >
            
                                            <v-flex xs6 sm6 md6 style="padding-left:2rem" >
                                                <span>
                                                    <v-btn flat icon v-on:click="startControl(subValue)">
                                                        <v-icon small color="purple">
                                                            {{model.fields.control.fields.commands.itemIcon}}
                                                        </v-icon>
                                                    </v-btn>
                                                    {{subValue.name}}
                                                </span>
                                            </v-flex>
                                            <v-flex xs5 sm5 md5 >
                                                <span>
                                                    {{subValue.label}}
                                                </span>
                                            </v-flex>
                                        </v-layout>
                                    </v-layout>
                                    
                                </v-card-text>
                            </v-card>            
                        </v-flex>-->
                    </v-layout>
                </v-tab-item> 

                <!-- Configuration view -->
                <v-tab-item
                    value="configuration"
                    v-if="model.fields.configuration"
                >

                    <v-layout row wrap style="margin-top:1rem">
                        <v-flex 
                            d-flex xs12 sm12 style="margin-top:1rem;"
                            v-if="model.fields.configuration.fields.fota"
                        >
                            <v-card  
                                tile flat class="elevation-2" style="text-align:left;padding-bottom:0.4rem"
                                v-if="resolve(model.fields.configuration.fields.fota.path,device)"
                            >
                                <v-card-title class="font-weight-medium">
                                    <v-icon small left>{{model.fields.configuration.fields.fota.icon}}</v-icon>
                                    <span>{{model.fields.configuration.fields.fota.label}}</span>
                                </v-card-title>
                                <div style="padding-left:1rem;padding-right:1rem">
                                <v-card-text> 
                                    <v-layout 
                                        align-center
                                        row-wrap
                                        style="margin-bottom:0.5rem"
                                    >
                                        <v-flex xs12 sm12 md12>
                                            <v-select
                                                v-model="selectedFirmwareName"
                                                :items="firmwaresName"
                                                prepend-icon="attach_file"
                                                label="Firmware file"
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        v-on:click="startFirmwareUpdate()"
                                        icon class="blue" dark
                                    >
                                        <v-icon
                                        >play_arrow
                                        </v-icon>
                                    </v-btn>
                                </v-card-actions>
                                </div>
                            </v-card>            
                        </v-flex>

                        <v-flex 
                            d-flex xs12 sm12 style="margin-top:1rem;"
                            v-if="model.fields.configuration.fields.neuralNetworkFota"
                        >
                            <v-card  
                                tile flat class="elevation-2" style="text-align:left;padding-bottom:0.4rem"
                                v-if="resolve(model.fields.configuration.fields.neuralNetworkFota.path,device)"
                            >
                                <v-card-title class="font-weight-medium">
                                    <v-icon small left>{{model.fields.configuration.fields.neuralNetworkFota.icon}}</v-icon>
                                    <span>{{model.fields.configuration.fields.neuralNetworkFota.label}}</span>
                                </v-card-title>
                                <div style="padding-left:1rem;padding-right:1rem">
                                <v-card-text> 
                                    <v-layout 
                                        align-center
                                        row-wrap
                                        style="margin-bottom:0.5rem"
                                    >
                                        <v-flex xs12 sm12 md12>
                                            <v-select
                                                v-model="selectedNeuralNetworkFirmwareName"
                                                :items="neuralNetworkFirmwareNames"
                                                prepend-icon="attach_file"
                                                label="Firmware file"
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        v-on:click="startNeuralNetworkFirmwareUpdate()"
                                        icon class="blue" dark
                                    >
                                        <v-icon
                                        >play_arrow
                                        </v-icon>
                                    </v-btn>
                                </v-card-actions>
                                </div>
                            </v-card>            
                        </v-flex>

                        <v-flex 
                            d-flex xs12 sm12 style="margin-top:1rem;"
                            v-if="model.fields.configuration.fields.aiAlgorithmSelection"
                        >
                            <v-card  
                                tile flat class="elevation-2" style="text-align:left;padding-bottom:0.4rem"
                                v-if="resolve(model.fields.configuration.fields.aiAlgorithmSelection.path,device)"
                            >
                                <v-card-title class="font-weight-medium">
                                    <v-icon small left>{{model.fields.configuration.fields.aiAlgorithmSelection.icon}}</v-icon>
                                    <span>{{model.fields.configuration.fields.aiAlgorithmSelection.label}}</span>
                                </v-card-title>
                                <div style="padding-left:1rem;padding-right:1rem">
                                <v-card-text> 
                                    <v-layout 
                                        align-center
                                        row-wrap
                                        style="margin-bottom:0.5rem"
                                    >
                                        <v-flex xs12 sm12 md12>
                                            <v-select
                                                v-model="selectedAlgorithmName"
                                                :items="resolve(model.fields.configuration.fields.aiAlgorithmSelection.pathAlgorithms,device)"
                                                prepend-icon="attach_file"
                                                label="Algorithm"
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        v-on:click="startSelectAIAlgorithm()"
                                        icon class="blue" dark
                                    >
                                        <v-icon
                                        >play_arrow
                                        </v-icon>
                                    </v-btn>
                                </v-card-actions>
                                </div>
                            </v-card>            
                        </v-flex>                
                    </v-layout>
                </v-tab-item>

                <!-- Gateway view -->
                <v-tab-item
                    value="gateway"
                    v-if="model.fields.gateway&&device.attributes.isGateway"
                >
                    <v-container>
                        <v-layout justify-end style="margin-bottom:1rem">
                            <v-btn class="ma-2" tile outline color="success"  v-on:click="openDeviceRegistrationProcess=true">
                                <v-icon left>add</v-icon> New
                            </v-btn>
                            <v-btn class="ma-2" tile outline color="blue"  v-on:click="fetchSlaveDevices()">
                                <v-icon center>sync</v-icon>
                            </v-btn>
                        </v-layout>
                        <v-layout row wrap v-for="(item,index) in slaves" :key="index" style="position:relative">
                                
                            <v-btn 
                                color="orange" style="margin-left:-1px;position:absolute;z-index:2;right:1rem;top:0.5rem" dark
                                v-if="slaves[index].attributes.claimed!=true"
                                v-on:click="claimDevice(slaves[index])"
                            >
                                <v-icon small dark style="margin-right:5px">lock_open</v-icon> Unlock
                            </v-btn>
                            <v-flex xs12>
                                <v-layout 
                                    row wrap
                                    class="grey" 
                                    v-bind:class="{
                                        deviceunlocked:slaves[index].attributes.claimed==true,
                                        devicelocked:slaves[index].attributes.claimed!=true,
                                    }"
                                    style="margin-bottom:2rem;position:relative"
                                >   
                                    <v-flex xs12 style="index-1">  
                                        <device 
                                            :device="item" 
                                            v-on:deviceSelected="showSlaveDeviceDetails($event)">
                                        </device>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12>
                                <div    
                                    id="registrationplaceholder" 
                                    class="deviceitem"
                                    style="width:100%;margin-left:0"
                                    v-on:click="openDeviceRegistrationProcess=true">
                                    <div style="position:relative;top:40%;font-size:2em;margin-top:-0.2em">+</div>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-tab-item>
                                
            </v-tabs-items>

            <register-device 
                v-if="openDeviceRegistrationProcess==true"
                v-on:abort="openDeviceRegistrationProcess=false"
                v-on:completed="openDeviceRegistrationProcess=false"
                :gateway="device.id"
            ></register-device>
        </v-layout>

        <formdialog 
            v-if="openControlDialog"
            :form="formControl" 
            :dialog="openControlDialog" 
            :shadow="false"
            v-on:submitForm="endControl($event)"
            v-on:rejectForm="endControl(null,true)"
        ></formdialog>

        <transition name="slide">
          <div 
            v-bind:class="{
              devicedetails:!$vuetify.breakpoint.xs,
              devicedetailsmobile:$vuetify.breakpoint.xs
            }" 
            style="background-color:white;z-index:3" 
            v-if="(index+1)<ids.length"
          >
            <router-view 
              v-on:leaveView="hideSlaveDeviceDetails()"
              :index="index+1"
              style="position:absolute;width:100%;height:100%;top:4.5rem"
              v-on:deviceDeleted="hideSlaveDeviceDetails()"
            />
          </div>
        </transition>
    </div>
</template>

<script>
    import Map from '@/components/MapView'
    import {FormPayload,Validator,FormStructField} from '@/components/models/FormDialog'   
    import { mapState } from 'vuex'
    
    export default {
        name:"DeviceDetails",

        data: function(){
            return {
                selectedFirmware:null,
                formControl: null,
                openControlDialog: false,
                stateDirty:false,
                tabs:null,
                selectedFirmwareName:null,
                selectedNeuralNetworkFirmwareName:null,
                selectedAlgorithmName:null,
                openDeviceRegistrationProcess:false,
                viewDisabledLabel:[],
                icons:{
                    'message':'message',
                    'measure': 'insert_chart',
                    'type': 'merge_type',
                    'bat': 'battery_charging_full',
                    'led': 'lightbulb',
                    'gpstime': 'timer'
                },
            }
        },

        props:{
            index: Number,
            values: Object
        },

        components: {
            'MapView': Map
        },
        computed: {
            ...mapState(
                {
                    deviceMetadata: state => state.metadata.models.data.device,
                    firmwares: state => state.devices.firmwares,
                    neuralNetworkFirmwares: state => state.devices.neuralNetworkFirmwares,
                    devices: state => state.devices.devices,
                    ids: state=> state.idsSnake
                }
            ),

            device: function(){
                return this.devices.find(device=>device.id==this.ids[this.index])
            },

            model: function(){
                let modelConfig = {
                    default : this.deviceMetadata.defaultIcon,
                    gatewayIcon : this.deviceMetadata.gatewayIcon,
                    inProgressView: this.deviceMetadata.inProgressView,
                    fields : {}
                }
                for(let indexTab in this.deviceMetadata.fields)
                {
                    switch(indexTab){
                        case 'gateway':
                            if(this.device.attributes.isGateway==true)        
                                modelConfig.fields[indexTab] = this.deviceMetadata.fields[indexTab]
                            break
                        default:
                              modelConfig.fields[indexTab] = this.deviceMetadata.fields[indexTab]              
                    }
                }
                return modelConfig
            },

            slaves: function(){
                return this.devices.filter(d => d.attributes.gateway==this.device.id)  
            },

            firmwaresName: function(){
                return this.firmwares.map(firmware => firmware.name)
            },
 
            neuralNetworkFirmwareNames: function(){
                return this.neuralNetworkFirmwares.map(firmware => firmware.name)
            },

            configuration:function(){
                let confObj = {}
                for(let index in this.model.fields.state.fields)
                    this.model.fields.state.fields[index].fields.forEach(element => {
                        if(element.configurable==true)
                            confObj[element.to] = this.resolve(element.path,this.device)
                    })
                return confObj
            },
            viewDisabled(){
                const reducer = (accumulator, currentValue) => accumulator | currentValue
                let labels = []
                let result = 
                    this
                        .model
                        .inProgressView
                        .fields
                        .map(f=>{
                            let r = false
                            if(this.resolve(f.path,this.device)){
                                r=this.resolve(f.path,this.device).toLowerCase()==f.value.toLowerCase() 
                                if(r==true){
                                    labels.push(f.label+": "+this.resolve(f.path,this.device))
                                }
                            }
                            return r
                        })
                        //.reduce(reducer)
                this.viewDisabledLabel= (labels.length>0)?labels.reduce((accumulator,value)=>accumulator+", "+value):""
                return (result.lenght>0)?result.reduce(reducer):false
            }
        },

        methods:{
            buildMarkers: function(geoLocations){
                let markers = [];
                geoLocations.forEach((geoLocation) => {
                    let coordinates = {
                        latitude: geoLocation.v.lat,
                        longitude: geoLocation.v.lon,
                        altitude: geoLocation.v.ele
                    };
                    let marker = {
                        id: this.device.id,
                        coordinates: coordinates,
                        htmlContentTooltip: getHtmlInfo(
                            (this.device.attributes.technologyImage)?this.device.attributes.technologyImage.image:null, 
                            this.device.attributes.customName,
                            this.device.id,
                            geoLocation.timestamp?new Date(geoLocation.timestamp):new Date(),
                            coordinates,
                            (this.device.attributes.technologyImage)?this.device.attributes.technologyImage.width:null
                        )
                    };
                    markers.push(marker);
                })  
                return markers;
            },

            deleteDevice: function(){
                if(confirm("Are you sure to delete device "+this.device.id+" ?")){
                    this.$store.dispatch("devices/deleteDevice",this.device)
                    this.$emit("deviceDeleted",this.device)
                }
            },

            updateConfigurationDevice: function(){
                let configurationObj = {
                    deviceId : this.device.id,
                    gatewayId: this.device.attributes.gateway,
                    configuration: this.configuration
                }
                this.$store.dispatch("devices/updateConfigurationDevice",configurationObj)
                .then(
                    () => this.$emit("deviceUpdated",this.device.id)
                )
            },
            
            startSelectAIAlgorithm(){
                if(this.selectedAlgorithmName){
                    let obj = {
                        deviceId : this.device.id,
                        gatewayId: this.device.attributes.gateway,
                        algorithm : this.selectedAlgorithmName
                    }
                    this.$store.dispatch("devices/selectAIAlgorithm",obj)
                        .then(() => this.$emit("firmwareUpdated",this.device.id))   
                }

            },
            
            startFirmwareUpdate(){
                let firmware = this.firmwares.find(firmware => this.selectedFirmwareName==firmware.name)
                if(firmware){
                    let obj = {
                        deviceId : this.device.id,
                        gatewayId: this.device.attributes.gateway,
                        firmware : firmware
                    }
                    this.$store.dispatch("devices/startFota",obj)
                        .then(() => this.$emit("firmwareUpdated",this.device.id))    
                        
                    this.selectedFirmwareName = null
                }
            },

            startNeuralNetworkFirmwareUpdate(){
                let firmware = this.neuralNetworkFirmwares.find(firmware => this.selectedNeuralNetworkFirmwareName==firmware.name)
                if(firmware){
                    let obj = {
                        deviceId : this.device.id,
                        gatewayId: this.device.attributes.gateway,
                        firmware : firmware
                    }
                    this.$store.dispatch("devices/startFota",obj)
                        .then(() => this.$emit("firmwareUpdated",this.device.id))    
                        
                    this.selectedNeuralNetworkFirmwareName = null
                }
            },

            startControl: function(controlItem){
                if(controlItem.args.length>0){
                    this.formControl = new FormPayload({
                        title: controlItem.name,
                    })
                    
                    for(let argIndex in controlItem.args){
                        let arg = controlItem.args[argIndex]
                        let field =  new FormStructField({
                            name: arg.name,
                            label: arg.name,
                            type: arg.type,
                            show: arg.show,
                            icon: null,
                            meter: false
                        })
                        let validator = new Validator({
                            regex: '.*',
                            required: false,
                            min: 0,
                            max: 999999
                        })
                        field.setValidator(validator)
                        this.formControl.addField(field)
                    }
                    this.openControlDialog = true
                }else{
                    this.formControl = new FormPayload({
                        title: controlItem.name,
                    })
                    this.endControl({})
                }
            },

            endControl: function(controlPayload,abort){
                if(abort==true){
                    this.openControlDialog = false
                    this.formControl = null
                }else{
                    let controlObj = {
                        deviceId : this.device.id,
                        gatewayId: this.device.attributes.gateway,
                        name : this.formControl.title,
                        payload : controlPayload
                    }
                    this.$store.dispatch("devices/controlDevice",controlObj)
                        .then(() => this.$emit("deviceControlled",this.device.id))
                    this.openControlDialog = false
                    this.formControl = null
                }
            },

            resolve: function(path, obj=self, separator='.') {
                if(path.length==0){
                    return obj
                }

                let properties = Array.isArray(path) ? path : path.split(separator)
                //return properties.reduce((prev, curr) => prev && prev[curr], obj)
                return properties.reduce(
                    (prev, curr) =>  {
                        if(prev)
                            if(!prev.getCaseInsensProp(curr))
                                return prev && prev[curr]
                            else
                                return prev && prev.getCaseInsensProp(curr)
                        else
                            return null
                    }, obj
                )
            },

            selectedTab: function(index){
                switch(index){
                    case 'gateway':
                        if(this.slaves.length<=0)
                            this.fetchSlaveDevices()
                        break
                    default:
                        break
                }
            },

            claimDevice:function(slaveDevice){
                this.$store.dispatch("devices/claimDevice",slaveDevice)
            },

            fetchSlaveDevices: function(){
                this.$store.dispatch("devices/fetchDevices",this.device)
            },

            showSlaveDeviceDetails:function(device){
                this.$store.commit('browseApp',{name:'slave',id:device.id})                
            },
            hideSlaveDeviceDetails:function(){
                this.$store.commit('browseApp',{name:'device',id:this.device.id})      
            },
            prepareList(items,model){
                let map = []
                let complex = false
                for(let index in items){
                    if(!map[items[index][model.view.groupingByPath]])
                        map[items[index][model.view.groupingByPath]]=[]
                    map[items[index][model.view.groupingByPath]].push(items[index])
                }
                let result = []
                for(let index in map){
                    complex|=(index!='undefined')
                    result.push({
                        group:(index=='undefined')?undefined:index,
                        items:map[index]
                    })
                }
                result.complex = complex
                return result
            }

        }
    }

function getHtmlInfo(img, customName, id, timestamp, coordinates, widthImg){
    let title = `
        <div style="height:40px;margin-top:-5px;align-content: left;">
        <img style="float: left;width:${widthImg}rem;margin-top:0.5rem" src="${img}"  onerror="this.style.display='none'">
        <div style="float: left;margin:12px;margin-top:7px;align-content: left;">
            <div style="font-weight: bold">${customName}</div>
            <div>${id}</div>
        </div>
        </div>
    `
    let body = `
        <div style="height:100px;align-content: left;padding:10px">
        <div>
            <span style="position:relative">
                <span class="material-icons" style="font-size:13px;position:absolute;left:0" >date_range</span>
                <span style="font-weight: bold;margin-left:15px">Timestamp:</span>
            </span> 
                ${timestamp.toString().split("GMT")[0]}
        </div>
        <div style="margin-top:3px">
            <span style="position:relative">
                <span class="material-icons" style="font-size:13px;position:absolute;left:0" >my_location</span>
                <span style="font-weight: bold;margin-left:15px">Coordinates:</span>
            </span> 
            <div style="margin-left:25px">
                <div><span style="font-weight: bold">Latitude:</span> ${coordinates.latitude}</div>
                <div><span style="font-weight: bold">Longitude:</span>  ${coordinates.longitude}</div>
                <div><span style="font-weight: bold">Altitude:</span>  ${coordinates.altitude}</div>
            </div>
        </div>
        </div>
    `
    return {
        title: title,
        body: body
    }
}
</script>